import Icon from '../components/Icon';

const Weather40Colored = Icon(
  'weather-40-colored',
  <>
    <path
      fill="#4C8BF9"
      d="M8.866 13.845a.75.75 0 0 1 .289 1.02l-2 3.584a.75.75 0 0 1-1.31-.731l2-3.583a.75.75 0 0 1 1.02-.29M11.023 17.34a.75.75 0 0 1 .304 1.017L9.66 21.44a.75.75 0 1 1-1.32-.713l1.667-3.084a.75.75 0 0 1 1.016-.303M16.655 14.866a.75.75 0 1 0-1.31-.731l-2 3.583a.75.75 0 0 0 1.31.731z"
    />
    <path
      fill="#D0D6CE"
      fillRule="evenodd"
      d="M4.722 7.84a6.5 6.5 0 0 1 12.133-2.528A4.85 4.85 0 1 1 17.183 15H5.6a3.633 3.633 0 0 1-.879-7.16"
      clipRule="evenodd"
    />
  </>
);

export default Weather40Colored;
